/** @deprecated code smell, should be cleaned up */
export const MASS_POLLUTANTS = [
  { label: "CO2e", dataKey: "co2_eq", mass: "mass_co2eq" },
  { label: "CO2", dataKey: "co2", mass: "mass_co2" },
  { label: "CH4", dataKey: "c1", mass: "mass_ch4" },
  { label: "N2O", dataKey: "n2o", mass: "mass_n2o" },
];
